import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/settings/store/mutations";
import { getters } from "@/components/settings/store/getters";
import { actions } from "@/components/settings/store/actions";
import { SettingsState } from "@/components/settings/types";

export const state: SettingsState = {
  settingsPageTitle: {
    heading: "",
    subHeading: ""
  },
  openPinOverlay: false,
  encodedPin: "",
  openRightSideMenu: false,
  activeCardIndex: undefined,
  activeCardSection: undefined,
  rightSideMenuTitle: {
    heading: "",
    subHeading: ""
  },
  userToEdit: undefined,
  confirmModalStatus: false,
  openConfirmModal: false,
  confirmModalMsg: "",
  channelCardCurrPos: undefined,
  channelCardNewPos: undefined
};

export const settings: Module<SettingsState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
